export const getGraphqlUrl = (portalData, queryOptions) => {
  if (portalData?.portalConfig?.graphQlUrl) {
    return portalData.portalConfig.graphQlUrl;
  } else {
    return queryOptions.url;
  }
};
